var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35.248 36.252L0.0039978 71.507L128.002 199.502L256 327.497L383.998 199.502L511.996 71.507L476.752 36.252L441.507 0.997009L348.754 93.746L256 186.496L163.246 93.746L70.493 0.997009L35.248 36.252Z","fill":"black"}));
}

DownChevron.defaultProps = {"width":"512","height":"328","viewBox":"0 0 512 328","fill":"none"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
